module.exports = __webpack_public_path__ + "static/media/stock-management.3c392b6f.svg";